import React from 'react'
import {
  Dashboard,
  CalendarToday,
  Settings,
  PersonAdd,
  Description,
  Payment,
  AddBox,
  Bookmark,
  Chat,
  Assignment,
} from '@mui/icons-material'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import CampaignIcon from '@mui/icons-material/Campaign'
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import PersonIcon from '@mui/icons-material/Person'
import PaidIcon from '@mui/icons-material/Paid'
import CardMembershipIcon from '@mui/icons-material/CardMembership'
import ReceiptIcon from '@mui/icons-material/Receipt'
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'
import PriceChangeIcon from '@mui/icons-material/PriceChange'
import SummarizeIcon from '@mui/icons-material/Summarize'
import ListAltIcon from '@mui/icons-material/ListAlt'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import CodeIcon from '@mui/icons-material/Code'
import HealingIcon from '@mui/icons-material/Healing'
import { Box } from '@mui/material'

import { NavigationItem, UserRole } from '../types/index'

export const navigationItems: NavigationItem[] = [
  {
    text: 'Dashboard',
    icon: <Dashboard />,
    path: '/dashboard',
    roles: [UserRole.CLIENT, UserRole.THERAPIST, UserRole.ADMIN],
  },

  // Patient Portal Links
  {
    text: 'PillarMatch',
    icon: (
      <Box
        component="img"
        src="/pillarMatchIcon.png"
        alt="PillarMatch"
        sx={{ width: 24, height: 24 }}
      />
    ),
    path: '/patient-pillar-match',
    roles: [UserRole.CLIENT],
  },
  {
    text: 'Calendar',
    icon: <CalendarToday />,
    path: '/schedule',
    roles: [UserRole.CLIENT],
  },
  {
    text: 'Jobs',
    icon: <PersonAdd />,
    path: '/jobs',
    roles: [UserRole.CLIENT],
  },
  {
    text: 'Contracts',
    icon: <Description />,
    path: '/contracts',
    roles: [UserRole.CLIENT],
  },
  {
    text: 'Proposals',
    icon: <Assignment />,
    path: '/patient-proposals',
    roles: [UserRole.CLIENT],
  },

  // Therapist Links
  {
    text: 'PillarMatch',
    icon: (
      <Box
        component="img"
        src="/pillarMatchIcon.png"
        alt="PillarMatch"
        sx={{ width: 24, height: 24 }}
      />
    ),
    path: '/pillar-match',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'Service Packages',
    icon: <AddBox />,
    path: '/service-packages',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'Calendar',
    icon: <CalendarToday />,
    path: '/therapist-schedule',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'Proposals',
    icon: <Description />,
    path: '/proposals',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'Contracts',
    icon: <SupervisedUserCircleIcon />,
    path: '/therapy-contracts',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'EVV Logs',
    icon: <ListAltIcon />,
    path: '/evv-logs',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'Invoices',
    icon: <ReceiptIcon />,
    path: '/invoices',
    roles: [UserRole.CLIENT, UserRole.THERAPIST],
  },
  {
    text: 'Claims',
    icon: <PriceChangeIcon />,
    path: '/claims',
    roles: [UserRole.CLIENT, UserRole.THERAPIST],
  },
  {
    text: 'Documents',
    icon: <SummarizeIcon />,
    path: '/documents-center',
    roles: [UserRole.THERAPIST],
  },
  {
    text: 'Documents',
    icon: <SummarizeIcon />,
    path: '/documents',
    roles: [UserRole.CLIENT],
  },

  // Admin Portal Links
  {
    text: 'Patients',
    icon: <PersonIcon />,
    path: '/patient',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'Providers',
    icon: <LocalHospitalIcon />,
    path: '/provider',
    roles: [UserRole.ADMIN],
  },

  // Grouped Menu for Admin: Plans & Transactions
  {
    text: 'Membership',
    icon: <CardMembershipIcon />,
    roles: [UserRole.ADMIN],
    collapsible: true,
    children: [
      {
        text: 'Plans',
        icon: <CalendarToday />,
        path: '/plan',
      },
      {
        text: 'Subscriptions',
        icon: <ChromeReaderModeIcon />,
        path: '/subscription',
      },
      {
        text: 'Transactions',
        icon: <PaidIcon />,
        path: '/transaction',
      },
      {
        text: 'Coupons',
        icon: <PaidIcon />,
        path: '/coupons',
      },
    ],
    path: '',
  },

  {
    text: 'Contracts',
    icon: <CalendarToday />,
    path: '/booking',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'Invoices',
    icon: <ReceiptIcon />,
    path: '/admin-invoices',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'Claims',
    icon: <PriceChangeIcon />,
    path: '/admin-claims',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'Revenue',
    icon: <RequestQuoteIcon />,
    path: '/billing',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'Audit Logs',
    icon: <SummarizeIcon />,
    path: '/audit-logs',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'Payer List',
    icon: <AccountBalanceIcon />,
    path: '/admin-payers',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'CPT Code List',
    icon: <CodeIcon />,
    path: '/admin-cpt-codes',
    roles: [UserRole.ADMIN],
  },
  {
    text: 'ICD Code List',
    icon: <HealingIcon />,
    path: '/admin-icd-codes',
    roles: [UserRole.ADMIN],
  },

  // Certificate Manager Links
  {
    text: 'PoC Documents',
    icon: <SummarizeIcon />,
    path: '/poc-documents',
    roles: [UserRole.CERTIFICATE_MANAGER],
  },
]

export const bottomNavigationItems: NavigationItem[] = [
  {
    text: 'Account settings',
    icon: <Settings />,
    path: '/account-settings',
    roles: [UserRole.CLIENT, UserRole.THERAPIST],
  },
]

export const filterNavigationByRole = (
  items: NavigationItem[],
  userRole: UserRole | null
): NavigationItem[] => {
  if (!userRole) return []

  return items
    .filter(item => {
      if (!item.roles || item.roles.length === 0) return true
      return item.roles.includes(userRole)
    })
    .map(item => {
      if (item.children) {
        return {
          ...item,
          children: filterNavigationByRole(item.children, userRole),
        }
      }
      return item
    })
}

export const getNavigationForRole = (role: UserRole | null) => {
  const mainItems = filterNavigationByRole(navigationItems, role)
  const bottomItems = filterNavigationByRole(bottomNavigationItems, role)

  return {
    mainItems,
    bottomItems,
  }
}
